import { RequestState } from "common/RequestState";

const isObj = o => o && o.constructor === Object;
const isInState = (request, expectedState, key) => {
  if (!request || !request._requestState) return false;
  var currentState = request._requestState;
  if (stateByKey(request, key) === expectedState) return true;

  //it might be useful to check if any request is in progress for example.
  if (!key && isObj(request._requestState)) {
    return Object.values(currentState).some(keyState => keyState === expectedState);
  }
  return false;
};

const stateByKey = (request, key = null) => {
  if (!request || !request._requestState) return null;
  if (!key) return request._requestState;
  return request._requestState[key];
};

export const isLoading = (request, key = null) => isNotRequested(request, key) || isInProgress(request, key);
export const isNotRequested = (request, key = null) =>
  !stateByKey(request, key) || isInState(request, RequestState.NotRequested, key);
export const isInProgress = (request, key = null) => isInState(request, RequestState.InProgress, key);
export const isFinished = (request, key = null) => isInState(request, RequestState.Finished, key);
export const isFailed = (request, key = null) => isInState(request, RequestState.Failed, key);
